module.exports = __webpack_public_path__ + "img/hire_report.d33552f3.png";